module.exports = __webpack_public_path__ + "media/pk_anim_wait.372dafa7.mp3";